/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-restricted-globals */
import { DomProps, ItemID } from 'componentregistry';

const domPropsCache: Map<ItemID, DomProps> = new Map();

export const getDomProps = (
  itemId: ItemID,
  defDomProps: DomProps,
): DomProps => {
  if (!domPropsCache.has(itemId)) {
    domPropsCache.set(itemId, defDomProps);
  }
  return domPropsCache.get(itemId) ?? defDomProps;
};

declare global {
  interface Window {
    _cloudio_: Map<string, Cache<any>>;
  }
}

self._cloudio_ = self._cloudio_ || new Map<string, Cache<any>>();

class Cache<T> {
  value: T;

  private _key: string;

  private _reset: (oldVal?: T) => T;

  constructor(key: string, reset: (oldVal?: T) => T) {
    this._reset = reset;
    this._key = key;
    this.value = this._reset();
  }

  reset = () => {
    this.value = this._reset(this.value);
  };
}

export const globalCache = {
  signingOut: false,
  get<T>(key: string, reset: (oldVal?: T) => T): Cache<T> {
    let value = self._cloudio_.get(key) as Cache<T>;
    if (value === undefined) {
      value = new Cache<T>(key, reset);
      self._cloudio_.set(key, value);
    }
    return value;
  },
  reset(key: string): void {
    const cache = self._cloudio_.get(key);
    cache?.reset();
  },
  clearAll(): void {
    self._cloudio_.forEach((val) => {
      val.reset();
    });
  },
};
